import React from "react";
import BulasikMakinaDeterjanı from "../Components/product/BulasikMakinaDeterjanı";
import PageHeader from "../Components/common/PageHeader";
import { t } from "i18next";
import ProductSEO from "../Components/common/ProductSEO";

function BulasikMakinaDeterjanıPage() {
    return (
        <>
            <ProductSEO
                name="Bulaşık Makina Deterjanı"
                description="Endüstriyel bulaşık makineleri için güçlü deterjan; yağ ve kirleri etkili şekilde çözer."
                slug="bulasikmakina"
                imagePath="assets/images/20-kg/6.webp"
            />
            <PageHeader title={t("BULAŞIK MAKİNA DETERJANı")} />
            <BulasikMakinaDeterjanı />
        </>
    );
}

export default BulasikMakinaDeterjanıPage;